exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".summary-card-small[data-v-b593fb3e]{padding:15px;border-radius:8px;color:#fff;text-align:center}.card-content-small h5[data-v-b593fb3e]{font-size:14px;margin:0 0 10px;opacity:.9}.card-content-small h4[data-v-b593fb3e]{font-size:24px;font-weight:600;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b593fb3e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/salesPersonDashboard/BillingSection.vue
// module id = 1784
// module chunks = 0